import { FirebaseDocRefType, FirebaseTimestampType } from 'firebase'

export type PointCardUserPointType = {
  brand_ref: FirebaseDocRefType
  point_card_ref: FirebaseDocRefType
  points: number
  point_source: PointCardUserPointSourceType
  user_id: string
  user_name: string
  created_at: FirebaseTimestampType
}

export const PointCardUserPointSource = {
  initial: 'カード獲得',
  checkout: 'sacri決済',
  code: 'QRコード',
  manual: 'その他',
} as const
export type PointCardUserPointSourceType = keyof typeof PointCardUserPointSource
